import React, { useEffect } from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { useInView } from 'react-intersection-observer';

import styles from './infiniteScroll.module.scss';

const InfiniteScroll = ({direction = 'vertical', children, loading, loadData}) => {
  const [inViewRef, inView, entry] = useInView({
    root: null,
    threshold: 0
  });

  useEffect(() => {
    if(inView){
      loadData();
    }
  }, [inView]);

  return (
    <React.Fragment>
      {children}
      {!loading &&
        <div ref={inViewRef} className={cx(styles.indicator, styles[direction])}>&nbsp;</div>
      }
    </React.Fragment>
  );
}

export default InfiniteScroll;